import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../shadcn/ui/card";
import { Button } from "../../shadcn/ui/button";
import { CheckCircle } from "lucide-react";

const GoToMail = () => {
  return (
    <div className="w-full max-w-md mx-auto px-4">
      <Card className="border-0 shadow-2xl">
        <CardHeader className="space-y-1">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
          </div>
          <CardTitle className="text-2xl font-semibold text-center">Check your email</CardTitle>
          <CardDescription className="text-center">We've sent you a password reset link</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-600 text-center">
            Please check your email inbox and click on the link we sent you to reset your password.
          </p>
          <p className="text-xs text-gray-500 text-center">If you don't see the email, check your spam folder.</p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-4">
          <Button asChild className="w-full">
            <Link to="/signin">Return to sign in</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default GoToMail;
